import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="policy-container">
      <h1>Rules & Regulations</h1>
      <p>
        Welcome to <strong>Forever Speed Skating Academy</strong>. These terms and conditions are designed to ensure a safe, respectful, and effective training environment for all students and parents. By enrolling or participating in any session, you agree to abide by the following rules and regulations.
      </p>

      <h2>1. Fee Payment</h2>
      <ul>
        <li>Fees must be paid in advance along with the admission form.</li>
        <li>All payments should be made <strong>on or before the 10th of every month</strong>.</li>
        <li>A late fine of ₹200 will be applicable for delayed payments. This amount is used to support underprivileged children with skating opportunities.</li>
        <li>Fees are <strong>non-refundable</strong> under any circumstances, including absenteeism or public holidays.</li>
      </ul>

      <h2>2. Safety Gear</h2>
      <ul>
        <li><strong>Helmet, Guard Set, and Club Bodysuit are compulsory</strong> for all students.</li>
        <li>Students arriving without proper gear may not be allowed to participate in the session.</li>
      </ul>

      <h2>3. Session Conduct</h2>
      <ul>
        <li>Parents and guardians are <strong>not allowed to interfere</strong> during ongoing sessions.</li>
        <li>Entry inside the skating rink is restricted to students and authorized coaches only.</li>
        <li>Students must maintain discipline and follow coach instructions at all times.</li>
      </ul>

      <h2>4. Public Holidays & Missed Classes</h2>
      <ul>
        <li>There will be <strong>no classes on public holidays</strong>.</li>
        <li>Missed classes will not be rescheduled or refunded.</li>
      </ul>

      <h2>5. Safety Disclaimer</h2>
      <p>
        Parents are responsible for ensuring the safety and preparedness of their child before and after the session. The <strong>FSSA team will not be held liable</strong> for any incident, accident, or injury occurring during or after the training.
      </p>

      <h2>6. Location Access</h2>
      <p>
        Our sessions are held at multiple venues in Mumbai, including:
      </p>
      <ul>
        <li>Airoli Sector 8A (Near Dmart, Opp. Sai Sneha Restaurant)</li>
        <li>Mg Road, Goregaon West (Aquanus International School)</li>
        <li>Naigaon West (CJM School, Opp. Pali Church)</li>
      </ul>

      <h2>7. Policy Updates</h2>
      <p>
        Forever Speed Skating Academy reserves the right to modify or update these rules and regulations without prior notice. Updated policies will be shared with students and guardians via email or in-session announcements.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        For any questions or clarifications, you may reach us at:
      </p>
      <ul>
        <li><strong>Email:</strong> fssacademy2020@gmail.com</li>
        <li><strong>Phone:</strong> +91 79775 63085</li>
        <li><strong>Instagram:</strong> <a href="https://www.instagram.com/foreverspeedskating" target="_blank" rel="noreferrer">@foreverspeedskating</a></li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
